import { HeaderMenu } from './HeaderMenu';

interface HeaderProps {
  route: string;
  learned: number;
  total: number;
}

const UNLOCK_THRESHOLD = 10; // learn 10 of 14 Tier-1 poses to preview Tier 2

export function Header({ route, learned, total }: HeaderProps) {
  const pct = total ? Math.round((learned / total) * 100) : 0;
  const unlocked = learned >= UNLOCK_THRESHOLD;
  const onRoutines = route.startsWith('/routines');
  const onDiscover = route === '/discover' || route.startsWith('/r/');
  const onPoses = !onRoutines && !onDiscover;

  return (
    <header className="site">
      <div className="wrap head-inner">
        <a className="brand" href="#/">
          <span className="brand-mark" aria-hidden="true" />
          <h1 className="brand-wordmark">Yoga Me</h1>
        </a>

        <nav className="nav">
          <a className={`nav-link${onPoses ? ' active' : ''}`} href="#/">
            Poses
          </a>
          <a className={`nav-link${onRoutines ? ' active' : ''}`} href="#/routines">
            Routines
          </a>
          <a className={`nav-link${onDiscover ? ' active' : ''}`} href="#/discover">
            Discover
          </a>
        </nav>

        <div className="progress" title={`${learned} of ${total} poses learned`}>
          <div className="progress-text">
            {unlocked ? 'Tier 2 unlocked 🎉' : `${learned}/${total} learned`}
          </div>
          <div className="bar">
            <span style={{ width: `${pct}%` }} />
          </div>
        </div>

        <HeaderMenu />
      </div>
    </header>
  );
}
